function Loader({ className }: { className?: string }) {
  return <img src="/images/spinner.svg" alt="" className={className} />;
}

export default Loader;
